// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'facebook';

export const Component = () => (
  <path d='M20.44 2.002c.719 0 1.34.24 1.868.766.526.479.766 1.102.766 1.82V20.44c0 .719-.239 1.34-.766 1.868-.528.527-1.15.766-1.868.766h-3.975v-7.567h2.778v-3.305h-2.778v-1.724c0-.479.239-.719.67-.719h2.107V6.023h-2.347c-1.197 0-2.203.432-3.017 1.341-.814.91-1.245 1.963-1.245 3.209V12.2h-2.538v3.304h2.538v7.568H4.634c-.718 0-1.34-.24-1.868-.767C2.24 21.78 2 21.157 2 20.438V4.586c0-.719.24-1.34.766-1.82A2.535 2.535 0 0 1 4.634 2H20.44v.002Z' />
);

export const viewBox = '0 0 25 25';
